import { Component, type ReactElement } from "react";
import { type InjectedFormProps } from "redux-form";

import { type IGenericCardConfiguration } from "../../redux/modules/dashboard.js";
import StopPortalPropagation from "./StopPortalEventsPropagation.js";
import { Dialog } from "./overlays/Dialogs.js";
import InputField, { InputReduxFormField } from "./redux-form/InputField.js";
import { simpleFieldValidation } from "@/app-utils/form.ts";
import { MAX_LENGTH } from "@/settings/settings.js";

export interface IGenericCardEditingProps {
  initialConfig: IGenericCardConfiguration;
  onClose: () => void;
  saveCardConfig: (configuration: IGenericCardConfiguration) => void;
}

interface IGenericCardEditingDialogProps extends IGenericCardEditingProps, InjectedFormProps<any, any> {
  handleSubmitData: (values) => void;
}

export default class GenericCardEditingDialog extends Component<IGenericCardEditingDialogProps> {
  public static CARD_EDITING_DIALOG_CARD_TITLE = "CARD_EDITING_DIALOG_CARD_TITLE";

  render(): ReactElement {
    return (
      <StopPortalPropagation>
        <Dialog
          headerProps={{ title: `Card Configuration` }}
          mainActionButtonProps={{
            children: `Save Configuration`,
            isDisabled: this.props.submitting,
            onPress: this.props.handleSubmit(this.props.handleSubmitData),
          }}
          footerMessage={{ message: this.props.error }}
          closeFn={() => {
            this.props.reset();
            this.props.onClose();
          }}
        >
          <div className={"dashboard-card-editing-form"}>
            {this.props.children}

            <div className={"dashboard-card-editing-form-section"}>
              <InputReduxFormField
                componentClass="input"
                name={GenericCardEditingDialog.CARD_EDITING_DIALOG_CARD_TITLE}
                label={`Card title`}
                placeholder={`Enter title`}
                maxLength={MAX_LENGTH.CARD.TITLE}
                component={InputField}
                //handleChange={this.debouncedProjectNameValidation}
                validate={simpleFieldValidation}
              />
            </div>
          </div>
        </Dialog>
      </StopPortalPropagation>
    );
  }
}
